import { Record } from 'immutable';

const PropertyMatchRecord = Record({
  matchingPropertyId: 0,
  vendorSource: null,
  vendorId: null,
  name: null,
  address1: null,
  address2: null,
  address3: null,
  city: null,
  stateProvinceCode: null,
  countryCode: null,
  postalCode: null,
  contactFirstName: null,
  contactLastName: null,
  contactEmail: null,
  contactPhone: null,
  contactFax: null
});

export class PropertyMatch extends PropertyMatchRecord {
  matchingPropertyId: number;
  vendorSource: string;
  vendorId: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  stateProvinceCode: string;
  countryCode: string;
  postalCode: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  contactPhone: string;
  contactFax: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/property-match.ts